var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "6", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M10.3333 6H8.11111C7.49833 6 7 6.49833 7 7.11111V9.33334C7 9.94612 7.49833 10.4444 8.11111 10.4444H10.3333C10.9461 10.4444 11.4444 9.94612 11.4444 9.33334V7.11111C11.4444 6.49833 10.9461 6 10.3333 6ZM10.3333 11.5555H8.11111C7.49833 11.5555 7 12.0539 7 12.6667V14.8889C7 15.5017 7.49833 16 8.11111 16H10.3333C10.9461 16 11.4444 15.5017 11.4444 14.8889V12.6667C11.4444 12.0539 10.9461 11.5555 10.3333 11.5555ZM13.666 11.5555H15.8882C16.501 11.5555 16.9993 12.0539 16.9993 12.6667V14.8889C16.9993 15.5017 16.501 16 15.8882 16H13.666C13.0532 16 12.5549 15.5017 12.5549 14.8889V12.6667C12.5549 12.0539 13.0532 11.5555 13.666 11.5555Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }